import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { DefaultPopup } from '@atlas/ui';

export const IFramePopup = ({ data, id, title }) => {
  const { allow = '', messageHandler, url } = data;

  useEffect(() => {
    if (typeof messageHandler !== 'function') {
      return;
    }

    const iframeURL = new URL(url);

    const eventHandler = event => {
      if (event.origin === iframeURL.origin) {
        messageHandler(event.data);
      }
    };

    window.addEventListener('message', eventHandler);

    return () => window.removeEventListener('message', eventHandler);
  }, [messageHandler, url]);

  return (
    <DefaultPopup
      className="popup-iframe"
      headerTitle={title}
      onClose={() => NotificationManager.removeNotification(id)}
    >
      <div className="popup__content">
        <iframe allow={allow} src={url} title="Iframe popup" />
      </div>
    </DefaultPopup>
  );
};

IFramePopup.propTypes = {
  data: PropTypes.shape({
    allow: PropTypes.string,
    messageHandler: PropTypes.func,
    url: PropTypes.string,
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
};
